// src/auth/authService.js
// Login contra la API (PostgreSQL). El backend devuelve un JWT propio.
import { apiPost, clearSession, MUST_CHANGE_KEY } from '../services/api';
import { fetchMe } from '../services/session';

/** Login con nombre de usuario y contraseña. Guarda token, rol y usuario en localStorage. */
export async function loginAndGetBackendToken(username, password) {
  const data = await apiPost('/auth/login', {
    username: String(username || '').trim(),
    password: String(password || ''),
  }).catch((e) => {
    clearSession();
    throw e;
  });

  if (!data?.token) {
    clearSession();
    throw new Error('Respuesta inválida del servidor (falta token)');
  }

  localStorage.setItem('token', data.token);
  localStorage.setItem('username', data.username || '');
  localStorage.setItem('role', String(data.role || 'viewer').toLowerCase());
  setMustChangePassword(data.mustChangePassword);
  return data;
}

/** DebeCambiarContrasena: mientras esté activo, las rutas privadas llevan a /cambiar-contrasena. */
export function setMustChangePassword(value) {
  try {
    if (value) localStorage.setItem(MUST_CHANGE_KEY, '1');
    else localStorage.removeItem(MUST_CHANGE_KEY);
  } catch {}
}

/** Cambia la contraseña propia. La API invalida las sesiones anteriores y devuelve un token nuevo. */
export async function changeOwnPassword(currentPassword, newPassword) {
  const data = await apiPost('/auth/change-password', { currentPassword, newPassword });
  if (data?.token) localStorage.setItem('token', data.token);
  setMustChangePassword(false);
  return data;
}

/** Perfil del usuario autenticado (uid, username, role, sucursalId). */
export async function getUserProfile() {
  return fetchMe();
}

/** Deja constancia del cierre de sesión en la bitácora (sin esperar respuesta). Debe llamarse antes de borrar el token. */
export function avisarCierreSesion() {
  apiPost('/auth/logout').catch(() => {});
}

export function logout() {
  avisarCierreSesion();
  clearSession();
}
